import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchAdditionalPaymentCategory } from '@/features/additional-payment-categories/api'

import { AdditionalPaymentCategoryParamsSchema } from '../-models/additional-payment-category-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/$additionalPaymentCategoryId'
)({
  parseParams: (params) => parse(AdditionalPaymentCategoryParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, additionalPaymentCategoryId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      additionalPaymentCategory: await fetchAdditionalPaymentCategory(
        {
          tenantKey,
          additionalPaymentCategoryId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.additionalPaymentCategory.name
    }
  ]
})
